import React, { useState, useEffect } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import Button from 'web/components/Button';
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import { showAppLoader, hideAppLoader } from 'redux/actions/app';

import { useHistory } from 'react-router-dom';
import { externalAccount } from 'redux/actions/payment';
import styles from '../../../corporate.module.scss';

const AccountForm = ({ props, setFieldValue, pageLanguageContents }) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  let history = useHistory();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [validateButtonEnable, setValidateButtonEnable] = useState(false)

  const loaderVisible = useSelector(    (state) => state.appReducer.loaderVisible  );

  useEffect(() => {
    let buyerOrSeller = props.values?.buyerSellerOption
    if ((props.values?.buyerPaymentValidated || buyerOrSeller === 'Seller') && !props.values?.sellerPaymentValidated) setValidateButtonEnable(true)
    else setValidateButtonEnable(false)
  }, [props])

  const submitHandler = async (props) => {
    if (props.values.accountHolderName.trim() !== '' && props.values.bankRouting.trim() !== '' && props.values.bankAccount.trim() !== '') {
      dispatch(showAppLoader())
      let bankAccountParams = {
        country: 'US',
        currency: 'usd',
        account_holder_name: props.values.accountHolderName,
        account_holder_type: 'individual',
        routing_number: props.values.bankRouting,
        account_number: props.values.bankAccount,
      };
      const result = await stripe.createToken('bank_account', bankAccountParams);
      if (result.error) {
        if (result.error.code === "account_number_invalid") {
          dispatch(hideAppLoader())
          setModalContent("Please enter valid Bank Account number.");
          setModalLink('');
          toggleModal();
        } else {
          dispatch(hideAppLoader())
          setModalContent(result.error.message);
          setModalLink('');
          toggleModal();
        }
      } else {
        setModalContent(pageLanguageContents?.Arrow2_Account[89]?.AccountValidated)
        setModalLink('');
        toggleModal();

        dispatch(hideAppLoader())
        
        setFieldValue('sellerPaymentValidated', true)
        localStorage.setItem('debiCardPaymentMethod', result.token.id);
      }
    } else {
      setModalContent("Please enter account holder name.");
      setModalLink('');
      toggleModal();
    }
  };

  return (
    <div>
      {loaderVisible && <Spinner />}
      <div >
        <p>{pageLanguageContents?.Arrow2_Account[38]?.Bank_Acctname}<span class="star">*</span></p>
        <div >
          <TextInput
            name='accountHolderName'
            // inputType="text"
            placeholder={pageLanguageContents?.Arrow2_Account[39]?.Bank_Acctname_Placeholder}
          />
        </div>
      </div>
      <div >
        <p>{pageLanguageContents?.Arrow2_Account[40]?.Bank_Acctnum}<span class="star">*</span></p>
        <div >
          <NumberInput
            name='bankAccount'
            placeholder={pageLanguageContents?.Arrow2_Account[41]?.Bank_Acctnum_Placeholder}
            maxLength='20'
          />
        </div>
      </div>
      <div >
        <p>{pageLanguageContents?.Arrow2_Account[42]?.Bank_Acctrouting}<span class="star">*</span></p>
        <div >
          <NumberInput
            name='bankRouting'
            placeholder={pageLanguageContents?.Arrow2_Account[43]?.Bank_Acctrouting_Placeholder}
            maxLength='20'
          />
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.fieldGroup}>
          <div>
            {!validateButtonEnable ?
              <button
                type='submit'
                className='app-greyDisabled-button'
                disabled={true}>
                {pageLanguageContents?.Arrow2_Account[53]?.SellerValid}
              </button>
              : <Button
                type='app-green-button'
                handleClick={() => submitHandler(props)}
              >
                {pageLanguageContents?.Arrow2_Account[53]?.SellerValid}
              </Button>}
          </div>
        </div>
      </div>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </div >
  );
};
export default AccountForm;
